import { render, staticRenderFns } from "./resumePage.vue?vue&type=template&id=0bd6159b&scoped=true&"
import script from "./resumePage.vue?vue&type=script&lang=js&"
export * from "./resumePage.vue?vue&type=script&lang=js&"
import style0 from "./resumePage.vue?vue&type=style&index=0&id=0bd6159b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd6159b",
  null
  
)

export default component.exports